import { dayjs } from '../utils/dayjs';

const DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
const DATE_FORMAT = 'YYYY-MM-DD';

export const defaultTimeRange = [dayjs().utc().subtract(30, 'day').startOf('day'), dayjs().utc().endOf('day')];

export const defaultTimeProps = {
    date_from: dayjs().utc().subtract(30, 'day').startOf('day'),
    date_to: dayjs().utc().endOf('day')
};

export const defaultTimezoneOffset = new Date().getTimezoneOffset() / 60;
export const PERFORMANCE_RETENTION_YEARS = 2;

/**
 * Oldest day brand performance data is available for.
 *
 * UTC-pinned to match the API floor day-for-day; a local floor would drift a calendar day west of UTC.
 * Deliberately kept at exactly 2 years: the API allows one further day of grace only to absorb the
 * `timezone_offset` shift on `date_from`, so do not widen the picker to match it.
 *
 * @returns {import('dayjs').Dayjs} Start of the UTC day exactly PERFORMANCE_RETENTION_YEARS ago.
 */
export const getPerformanceRetentionFloor = () =>
    dayjs().utc().subtract(PERFORMANCE_RETENTION_YEARS, 'year').startOf('day');

/**
 * antd `disabledDate` predicate for the performance range pickers.
 *
 * @param {import('dayjs').Dayjs} [current] Date of the cell offered by the picker.
 * @returns {boolean} True when the date falls outside the retention window.
 */
export const disabledPerformanceDate = (current) =>
    !!current && dayjs.utc(current.format(DATE_FORMAT)).isBefore(getPerformanceRetentionFloor(), 'day');

/**
 * Raises a persisted (URL / localStorage) performance date up to the retention floor.
 *
 * @param {string} [date] Datetime string as persisted by the performance filters.
 * @returns {string} The input when inside the window, otherwise the floor in the same format.
 */
export const clampToPerformanceRetentionFloor = (date, { endOfDay = false } = {}) => {
    const floor = getPerformanceRetentionFloor();
    if (!dayjs(date).isBefore(floor)) return date;
    return (endOfDay ? floor.endOf('day') : floor).format(DATETIME_FORMAT);
};
